const body = document.body;

const matches = document.querySelectorAll("i.dropdown")

matches.forEach((item) => item.addEventListener("click", (e) => {
  const ul = item.parentNode.parentNode.querySelector("ul.dropdown-menu")
  if (ul) {
    e.preventDefault()
    e.stopPropagation()
    item.classList.toggle("fa-angle-down")
    item.classList.toggle("fa-angle-up")
    ul.classList.toggle("d-block")
  }
}))
